import { View } from '@react-pdf/renderer';
import { divideDataBetweenTables } from 'PDF/helpers/pdfMapping';

import { FeaturesTable, IFeaturesTableRowItem } from './FeaturesTable';
import { SmallHeading } from '../SmallHeading';

interface IFeaturesTableWrapperProps {
  rows: IFeaturesTableRowItem[];
  heading?: string;
}

export const FeaturesTableWrapper = ({ rows, heading }: IFeaturesTableWrapperProps) => {
  if (
    !rows.filter(({ items }) => items.filter((item) => (typeof item === 'object' ? item.imgSrc : item)).length).length
  ) {
    return null;
  }

  const arraysOfRows: IFeaturesTableRowItem[][] =
    rows[0].items.length > 3 ? divideDataBetweenTables(rows, 'items') : [rows];

  return (
    <View >
      {heading && <SmallHeading heading={heading} />}
      {arraysOfRows.map((rows, index) => (
        <View key={index} style={{ marginBottom: 30 }}>
          <FeaturesTable rows={rows} noCapturedFirstColumn={index !== 0} />
        </View>
      ))}
    </View>
  );
};
